export const SOURCE = {
  FOOTER_BANNER: 'avs_footer_banner',
  AVS_BANNER: 'avs_banner',
  LIMIT_BANNER: 'limit_banner',
  REVEAL_NAME: 'reveal_name',
  REVEAL_NAME_CALLOUT: 'reveal_name_callout',
  AVS_GUIDE: 'avs_guide',
  AVS_PAGE: 'avs_page',
};

export const accountVerificationAnalytics = {
  trackBulkVerifyClick: applicationId => {
    window.analytics.track('avsBulkVerifyClicked', {
      application_id: applicationId,
    });
  },

  trackLearnMoreClick: (source, applicationId) => {
    window.analytics.track('avsLearnMoreClicked', {
      source,
      application_id: applicationId,
    });
  },

  trackGetStartedClick: (source, applicationId) => {
    window.analytics.track('avsGetStartedClicked', {
      source,
      application_id: applicationId,
    });
  },

  trackUpgradeClick: (params, applicationId) => {
    window.analytics.track('avsUpgradeClicked', {
      ...params,
      application_id: applicationId,
    });
  },

  trackVerifyClick: (accountType, applicationId) => {
    window.analytics.track('avsVerifyClicked', {
      account_type: accountType,
      application_id: applicationId,
    });
  },

  trackPromotionBannerTryNowClick: applicationId => {
    window.analytics.track('AvsPromotionBannerTryNowClick', {
      applicationId,
    });
  },

  trackPromotionBannerCloseClick: applicationId => {
    window.analytics.track('AvsPromotionBannerCloseClick', {
      applicationId,
    });
  },

  trackNavigationItemClick: applicationId => {
    window.analytics.track('AvsNavigationItemClick', {
      applicationId,
    });
  },

  trackProTipDismiss: applicationId => {
    window.analytics.track('avsProTipDismissed', {
      application_id: applicationId,
    });
  },

  trackGuideStarted: (source, applicationId) => {
    window.analytics.track('avsGuideStarted', {
      source,
      application_id: applicationId,
    });
  },

  trackGuideStepViewed: (step, stepTitle, applicationId) => {
    window.analytics.track('avsGuideStepViewed', {
      step,
      step_title: stepTitle,
      application_id: applicationId,
    });
  },

  trackGuideStepCompleted: (step, stepTitle, applicationId) => {
    window.analytics.track('avsGuideStepCompleted', {
      step,
      step_title: stepTitle,
      application_id: applicationId,
    });
  },

  trackGuideCompleted: (totalSteps, applicationId) => {
    window.analytics.track('avsGuideCompleted', {
      total_steps: totalSteps,
      application_id: applicationId,
    });
  },

  trackGuideSkipped: (currentStep, totalSteps, applicationId) => {
    window.analytics.track('avsGuideSkipped', {
      current_step: currentStep,
      total_steps: totalSteps,
      application_id: applicationId,
    });
  },

  trackGuideDismissed: (currentStep, totalSteps, reason, applicationId) => {
    window.analytics.track('avsGuideDismissed', {
      current_step: currentStep,
      total_steps: totalSteps,
      reason,
      application_id: applicationId,
    });
  },
};
